import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Plus } from 'lucide-react';

import Icon from 'components/icon/Icon';
import { buttonVariants } from 'components/ui/button';
import { PATH_ROUTES } from 'routes/path';

export default function GenerateReport() {
  const { t } = useTranslation();

  const renderGenerateButton = () => {
    return (
      <Link
        to={PATH_ROUTES.GENERATE_SYMPTOM_CHECKER}
        className={buttonVariants({
          variant: 'default',
          className:
            'w-full h-16 !bg-blue-600 !rounded-2xl !hover:bg-blue-600/90',
        })}
      >
        <Plus className='mr-2 size-6 shrink-0' />
        <span className='font-semibold leading-tight text-left whitespace-pre'>
          {t('check_symptoms')}
        </span>
      </Link>
    );
  };

  return (
    <div>
      <div className='max-w-xl mx-auto lg:hidden'>{renderGenerateButton()}</div>

      <div className='hidden px-6 py-4 space-y-6 bg-blue-100 lg:block rounded-2xl'>
        <div className='space-y-3'>
          <div className='flex items-center justify-between gap-x-4'>
            <h2 className='text-xl font-semibold leading-tight text-blue-500'>
              {t('generate_symptom_title')}
            </h2>

            <Icon
              icon='symptom-checker'
              size={30}
              color='#1A68D8'
              className='shrink-0'
            />
          </div>
          <p className='font-medium leading-tight'>
            {t('generate_symptom_desc')}
          </p>
        </div>
        {renderGenerateButton()}
      </div>
    </div>
  );
}
